import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { PORTFOLIO_IMAGES } from "../lib/content";

const FALLBACK = [
  { _id: "b1", slug: "five-rules-for-elevated-branding", title: "Five Rules for Elevated Branding", excerpt: "What separates polished from prestige.", author: "Studio Editorial", cover_image_url: PORTFOLIO_IMAGES[2], created_at: "2025-01-01", tags: ["Branding"] },
  { _id: "b2", slug: "image-vs-influence", title: "Image vs. Influence", excerpt: "Why position beats presentation every time.", author: "Studio Editorial", cover_image_url: PORTFOLIO_IMAGES[3], created_at: "2025-02-04", tags: ["Strategy"] },
  { _id: "b3", slug: "the-pulpit-as-platform", title: "The Pulpit as Platform", excerpt: "An editorial framework for public-facing pastors.", author: "Studio Editorial", cover_image_url: PORTFOLIO_IMAGES[4], created_at: "2025-02-14", tags: ["Image"] },
];

export function BlogList() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setItems(r.data.length ? r.data : FALLBACK)).catch(() => setItems(FALLBACK));
  }, []);
  return (
    <div data-testid="blog-list-page">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-28 md:pt-40 pb-12">
        <div className="eyebrow text-[var(--crest-gold)]">— Insights</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight mt-6 leading-[1.02] max-w-3xl">Editorial dispatches from the studio.</h1>
      </section>
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-32 grid md:grid-cols-3 gap-10">
        {items.map((p, i) => (
          <Link to={`/blog/${p.slug}`} key={p._id || i} className="group" data-testid={`blog-item-${i}`}>
            <div className="aspect-[5/6] overflow-hidden">
              <img src={p.cover_image_url || PORTFOLIO_IMAGES[i % PORTFOLIO_IMAGES.length]} alt={p.title} className="luxe-img w-full h-full object-cover" />
            </div>
            <div className="pt-5">
              <div className="eyebrow text-[var(--crest-gold)]">{(p.tags && p.tags[0]) || "Editorial"}</div>
              <div className="font-serif text-2xl mt-2 group-hover:text-[var(--crest-gold)] transition-colors">{p.title}</div>
              <p className="text-sm text-[var(--crest-muted)] mt-2 leading-relaxed">{p.excerpt}</p>
              <div className="text-xs text-[var(--crest-muted)] mt-3 tracking-widest uppercase">{p.author}</div>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => {
      const fb = FALLBACK.find((b) => b.slug === slug);
      setPost(fb ? { ...fb, body: "<p>Editorial body content. In production this is fetched from the CMS.</p>" } : null);
    });
  }, [slug]);
  if (!post) return <div className="max-w-[800px] mx-auto px-6 py-40">Loading…</div>;
  return (
    <article className="max-w-[800px] mx-auto px-6 py-28 md:py-40" data-testid="blog-post-page">
      <div className="eyebrow text-[var(--crest-gold)]">{(post.tags && post.tags[0]) || "Editorial"}</div>
      <h1 className="font-serif text-5xl md:text-6xl tracking-tight mt-6 leading-[1.04]">{post.title}</h1>
      <div className="text-sm text-[var(--crest-muted)] mt-4 tracking-widest uppercase">{post.author}</div>
      {post.cover_image_url && <img src={post.cover_image_url} alt="" className="w-full h-[420px] object-cover mt-12" />}
      <div className="prose font-serif mt-12 text-lg leading-relaxed" dangerouslySetInnerHTML={{ __html: post.body || post.excerpt }} />
    </article>
  );
}
